module.exports = __webpack_public_path__ + "img/about6.b2560e2c.jpg";